module.exports = __webpack_public_path__ + "img/제주도 스테이크.1fa7984a.png";